import { render, staticRenderFns } from "./editProp.vue?vue&type=template&id=70ccf46a&scoped=true&"
import script from "./editProp.vue?vue&type=script&lang=ts&"
export * from "./editProp.vue?vue&type=script&lang=ts&"
import style0 from "./editProp.vue?vue&type=style&index=0&id=70ccf46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ccf46a",
  null
  
)

export default component.exports